export default (refs) => {
    const fieldsToValidate = Object.keys(refs)
        .map((ref) => refs[ref])
        .filter((component) => component.isFieldValid);
    return fieldsToValidate.map((field) => field.isFieldValid()).every((isValid) => isValid === true);
};
